/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { ListItemIcon } from '@mui/material';

import { createProjectListIconStyles } from './ProjectListItem.styles';

type ProjectListItemProps = {
  icon: React.ReactElement<any>;
  text: string;
  description?: string;
};

export function ProjectListItem(props: ProjectListItemProps) {
  const { description, icon, text } = props;
  const classes = createProjectListIconStyles({ size: 'small' });
  return (
    <>
      <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
      <div className={classes.textContainer}>
        <div className={classes.text}>{text}</div>
        {description && <div className={classes.description}>{description}</div>}
      </div>
    </>
  );
}
